/**
 * Normalize categories to always be an array of objects with `label` and `categories` keys
 */
export const getNormalizedCatgories = categories => {
  const normalizedCategories = Array.isArray(categories)
    ? categories.map(category =>
        'categories' in category && Array.isArray(category.categories)
          ? category
          : { label: null, categories: [category] },
      )
    : [{ label: categories.label || null, categories: categories.categories || categories }];

  return normalizedCategories;
};
